import './featured-product.scss';
